module.exports = __webpack_public_path__ + "6fdd22680fa613e947a873d3fac9cb58.MP3";